import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { landOnRouteTarget } from "@/lib/landOn";

/**
 * INTENT PRESERVATION for the router.
 *
 * React Router does not restore or reset scroll, and the dashboard scrolls inside `<main>`
 * rather than the window. So clicking a nav item while scrolled down swapped the content and
 * left the user at the old offset, mid-page, in a view they had never seen the top of — a
 * silent active-state change that reads as "nothing happened".
 *
 * On every pathname change we take the new route to its own top and focus its landing target
 * (`[data-landing]`, else its `<h1>`), with a brief ring. Search/hash changes are ignored so
 * filtering a list does not yank the user around.
 */
export function RouteLanding() {
  const { pathname } = useLocation();
  useEffect(() => {
    landOnRouteTarget();
  }, [pathname]);
  return null;
}

export default RouteLanding;
